import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError, finalize } from 'rxjs/operators';
import { PortalContextProvider } from '@core';
import { PortalType } from '@shared';
import { StatusRepository } from '../../../infrastructure/repositories/status.repository';
import { StatusState } from '../../states/status.state';
import { GetAllStatusesResult } from './get-all-statuses.result';

@Injectable()
export class GetAllStatusesUseCase {
  private readonly repository = inject(StatusRepository);
  private readonly state = inject(StatusState);
  private readonly portalContext = inject(PortalContextProvider);

  execute(): Observable<GetAllStatusesResult> {
    this.state.setLoading(true);
    this.state.clearError();

    const isCases = this.portalContext.currentPortalType() === PortalType.Cases;

    return this.repository.getAllStatuses().pipe(
      tap((statuses) => {
        if (isCases) {
          this.state.setCasesStatuses(statuses);
        } else {
          this.state.setInvestigationsStatuses(statuses);
        }
      }),
      map((statuses) => ({ statuses })),
      catchError((error) => {
        this.state.setError(error.message || 'Failed to load statuses');
        throw error;
      }),
      finalize(() => {
        this.state.setLoading(false);
      }),
    );
  }
}
